import React, { useEffect, useState } from "react";
import "./OrderAbout.scss";
import { useBackButton } from "../../hooks/useBackButton";
import Header from "../../components/Header";
import SubHeader from "../../components/SubHeader";
import { useNavigate } from "react-router-dom";
import TabsHeader from "../../components/TabsHeader";
import TabsBody from "../../components/TabsBody";

const OrderAbout = () => {
  const navigate = useNavigate();
  useBackButton("/", false, false);

const [activeTab, setActiveTab] = useState(0);
  const tabs = [
    { label: "Предложение" },
    { label: "Описание" }
  ];

  return (
    <>
      <Header></Header>
      <SubHeader></SubHeader>
      <div class="row order-about">
        <div class="col col-0 cancel col-md-3">
          <div class="return-btn" onClick={() => {navigate("/orders")}}>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0 20C0 16.2828 0 14.4241 0.307436 12.8786C1.56994 6.53151 6.53151 1.56994 12.8786 0.307436C14.4241 0 16.2828 0 20 0C23.7172 0 25.5759 0 27.1214 0.307436C33.4685 1.56994 38.4301 6.53151 39.6926 12.8786C40 14.4241 40 16.2828 40 20C40 23.7172 40 25.5759 39.6926 27.1214C38.4301 33.4685 33.4685 38.4301 27.1214 39.6926C25.5759 40 23.7172 40 20 40C16.2828 40 14.4241 40 12.8786 39.6926C6.53151 38.4301 1.56994 33.4685 0.307436 27.1214C0 25.5759 0 23.7172 0 20Z"
                fill="white" />
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M23.0893 14.4108C22.7638 14.0854 22.2362 14.0854 21.9108 14.4108L16.9108 19.4108C16.7545 19.5671 16.6667 19.7791 16.6667 20.0001C16.6667 20.2211 16.7545 20.4331 16.9108 20.5893L21.9108 25.5893C22.2362 25.9148 22.7638 25.9148 23.0893 25.5893C23.4147 25.2639 23.4147 24.7363 23.0893 24.4108L18.6785 20.0001L23.0893 15.5893C23.4147 15.2639 23.4147 14.7363 23.0893 14.4108Z"
                fill="#191A21" />
            </svg>
            Назад
          </div>
        </div>
        <div class="col col-12 col-md-9 order-static-center">
          
        </div>
        <div class="col col-12 relative static-translate">
          <div class="static-475">
            <div class="static-center">
              <div class="static-container">
                <TabsHeader
                  tabs={tabs}
                  activeTab={activeTab}
                  onTabChange={setActiveTab}
                />  
              </div>
            </div>
            <TabsBody activeTab={activeTab}>
              <div class="row mt-4">
                <div class="col col-12">
                  <div class="card">
                    <div class="">
                      <label for="">Тип оплаты</label>
                      <p>Целиком после выполнения</p>
                    </div>
                  </div>
                </div>
                <div class="col col-12">
                  <div class="card">
                    <h2>Этап 1</h2>
                    <div class="">
                      <label for="">Название этапа</label>
                      <p>Разработка прототипа</p>
                    </div>
                    <div class="">
                      <label for="">Что получит клиент?</label>
                      <p>Файл с макетом</p>
                    </div>
                    <div class="">
                      <label for="">Сроки выполнения этапа</label>
                      <p>7 дней</p>
                    </div>
                    <div class="">
                      <label for="">Стоимость</label>
                      <p>20 000 ₽</p>
                    </div>
                  </div>
                </div>
                <div class="col col-12">
                  <div class="card">
                    <h2>Этап 2</h2>
                    <div class="">
                      <label for="">Название этапа</label>
                      <p>Разработка прототипа</p>
                    </div>
                    <div class="">
                      <label for="">Что получит клиент?</label>
                      <p>Файл с макетом</p>
                    </div>
                    <div class="">
                      <label for="">Сроки выполнения этапа</label>
                      <p>7 дней</p>
                    </div>
                    <div class="">
                      <label for="">Стоимость</label>
                      <p>12 000 ₽</p>
                    </div>
                  </div>
                </div>
                <div class="col col-12">
                  <button class="btn btn-black">Оплатить 20 000 ₽</button>
                </div>
                <div class="col col-12 mt-2 mb-5">
                  <button class="btn btn-no-background">Отказаться</button>
                </div>
              </div>
              <div class="row mt-4">

              </div>
            </TabsBody>
          </div>
        </div>
      </div>
    </>
  );
}

export default OrderAbout;